import { combineReducers } from '@reduxjs/toolkit';
import createAdditionalReportReducer from './create-additional-report';
import createAdditionalReportListReducer from './create-additional-report-list';
import getAdditionalReportListReducer from './get-additional-report-list';
import getAdditionalReportSignedUrlReducer from './get-additional-report-signed-url';
import updateAdditionalReportReducer from './update-additional-report';

const additionalReportReducer = combineReducers({
  createAdditionalReport: createAdditionalReportReducer,
  createAdditionalReportList: createAdditionalReportListReducer,
  getAdditionalReportList: getAdditionalReportListReducer,
  getAdditionalReportSignedUrl: getAdditionalReportSignedUrlReducer,
  updateAdditionalReport: updateAdditionalReportReducer
});

export default additionalReportReducer;